// src/services/legalService.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api/v1';

export const legalService = {
  /**
   * Get privacy policy for a specific user type
   * @param {string} userType - customer, vendor, partner, admin, or all
   */
  getPrivacyPolicy: async (userType = 'all') => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/legal-documents/privacy_policy/`,
        {
          params: { user_type: userType }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      throw error;
    }
  },

  /**
   * Get terms and conditions for a specific user type
   * @param {string} userType - customer, vendor, partner, admin, or all
   */
  getTermsConditions: async (userType = 'all') => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/legal-documents/terms_conditions/`,
        {
          params: { user_type: userType }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching terms and conditions:', error);
      throw error;
    }
  },

  /**
   * Get all legal documents for a specific user type
   * @param {string} userType - customer, vendor, partner, admin, or all
   */
  getAllDocumentsByUserType: async (userType) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/legal-documents/by-user-type/`,
        {
          params: { user_type: userType }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching legal documents:', error);
      throw error;
    }
  },

  /**
   * Get all legal documents with optional filters
   * @param {Object} filters - { user_type, document_type }
   */
  getAllDocuments: async (filters = {}) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/legal-documents/`,
        {
          params: filters
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching legal documents:', error);
      throw error;
    }
  }
};